import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import Title from "../Title";

function NoirPlayerPrivacy() {
  document.title = "Noir Player プライバシーポリシー | 株式会社PO";

  return (
    <div id="privacyPage">
      <Header />
      <div className="contents_inner">
        <Title>Privacy Policy</Title>

        <div className="layout">
          <div className="postBox">
            <div className="postWrap" style={{ display: "block" }}>
              <article className="privacyArticle">
                <h2>Noir Player プライバシーポリシー</h2>
                <p>制定日：2026年10月21日</p>
                <p>運営者：株式会社PO</p>
                <p>
                  Noir Player（以下「本アプリ」）では、ユーザーのプライバシーを尊重し、個人情報の保護に努めています。
                </p>

                <h3>1. 取得する情報について</h3>
                <p>
                  本アプリは、氏名、メールアドレス、住所、電話番号など、個人を特定できる情報を開発者が取得することはありません。
                </p>
                <p>
                  本アプリの表示設定（キーカラー、文字サイズ、アイコンサイズ、ビジュアライザーなど）は、ユーザーの端末内に保存されます。
                </p>

                <h3>2. ミュージックライブラリへのアクセスについて</h3>
                <p>
                  本アプリは、曲・アルバム・アーティスト・プレイリストの表示および再生を行うため、ユーザーの許可を得た上で端末のミュージックライブラリ（Apple Music / iOSの「ミュージック」アプリのライブラリ）にアクセスします。
                </p>
                <p>
                  本アプリはライブラリの内容を読み取って表示・再生するのみで、ライブラリの曲やプレイリストを追加・変更・削除することはありません。
                </p>
                <p>
                  ライブラリの情報や再生状況は端末内でのみ処理され、開発者のサーバーへ送信、収集することはありません。また、第三者へ提供することもありません。
                </p>
                <p>
                  ミュージックライブラリへのアクセス許可は、端末の「設定」アプリからいつでも変更できます。
                </p>

                <h3>3. Apple Music の加入状況について</h3>
                <p>
                  本アプリは、Apple Music のカタログ曲を再生できるかどうかを判断するため、Apple が提供する MusicKit を通じて Apple Music の加入状況を確認します。
                </p>
                <p>
                  この確認は Apple の仕組みを通じて行われ、開発者がユーザーの Apple ID やアカウント情報、支払い情報を取得することはありません。
                </p>

                <h3>4. 広告・アプリ内課金について</h3>
                <p>
                  現在、本アプリでは広告の表示およびアプリ内課金を行っていません。
                </p>

                <h3>5. アクセス解析について</h3>
                <p>
                  現在、本アプリでは第三者のアクセス解析サービスを利用していません。また、トラッキングを目的とした情報の取得も行っていません。
                </p>

                <h3>6. 第三者への情報提供について</h3>
                <p>
                  本アプリは、ユーザーのミュージックライブラリの内容や設定内容を、第三者へ提供または販売することはありません。ただし、法令に基づく場合はこの限りではありません。
                </p>

                <h3>7. データの管理について</h3>
                <p>
                  ミュージックライブラリの曲やプレイリストは Apple のミュージックライブラリに保存されており、本アプリを削除しても削除されません。
                </p>
                <p>
                  本アプリの表示設定は、アプリを削除すると端末から削除されます。
                </p>

                <h3>8. プライバシーポリシーの変更について</h3>
                <p>
                  本アプリの機能追加、使用するサービスの変更、法令その他の必要に応じて、本プライバシーポリシーを変更することがあります。
                </p>
                <p>
                  変更後のプライバシーポリシーは、本ページに掲載した時点から適用されます。
                </p>

                <h3>9. お問い合わせ</h3>
                <p>
                  本アプリおよび本プライバシーポリシーに関するお問い合わせは、開発者Webサイトのお問い合わせ窓口よりお願いいたします。
                  <br />
                  株式会社PO
                  <br />
                  <a href="/#contact" className="link">
                    お問い合わせフォームはこちら
                  </a>
                </p>

                <p style={{ marginTop: "28px" }}>
                  制定日：2026年10月21日
                  <br />
                  Noir Player
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NoirPlayerPrivacy;
